import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/checkbox-item/checkbox-item.js';
      import {ObcCheckboxChangeEvent, CheckboxStatus} from '@oicl/openbridge-webcomponents/dist/components/checkbox/checkbox.js';
import {ObcCheckboxItemState, ObcCheckboxItemHoverStyle} from '@oicl/openbridge-webcomponents/dist/components/checkbox-item/checkbox-item.js';

      export interface Props {
     status?: CheckboxStatus;
     state?: ObcCheckboxItemState;
     disabled?: boolean;
     label?: string;
     isNested?: boolean;
     isLevel1?: boolean;
     isLevel2?: boolean;
     hoverStyle?: ObcCheckboxItemHoverStyle;
     ariaDescribedBy?: string
   }

      
  
      export type {ObcCheckboxChangeEvent, CheckboxStatus} from '@oicl/openbridge-webcomponents/dist/components/checkbox/checkbox.js';
export type {ObcCheckboxItemState, ObcCheckboxItemHoverStyle} from '@oicl/openbridge-webcomponents/dist/components/checkbox-item/checkbox-item.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcCheckboxItem',
  props: {
    status: {},
    state: {},
    disabled: { type: Boolean },
    label: {},
    isNested: { type: Boolean },
    isLevel1: { type: Boolean },
    isLevel2: { type: Boolean },
    hoverStyle: {},
    ariaDescribedBy: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onChange: (event: ObcCheckboxChangeEvent) => emit('change', event as ObcCheckboxChangeEvent)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-checkbox-item',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})